document.addEventListener("DOMContentLoaded", function () {
  console.log("âœ… Iniciando personalizaciÃ³n...");

  // Obtener datos de los metafields inyectados por Liquid
  const coloresCollar = window.productMetafields?.coloresCollar || [];
  const coloresTexto = window.productMetafields?.coloresTexto || [];
  const emojisDisponibles = window.productMetafields?.emojisDisponibles || [];
  console.log("ðŸŽ¨ Colores de collar:", coloresCollar);
  console.log("ðŸ– ï¸  Estilos (colores/texturas):", coloresTexto);
  console.log("ðŸ˜Š Emojis disponibles:", emojisDisponibles);

  // Obtener elementos del DOM
  const collarColorPicker = document.getElementById("collar-color-picker");
  const textStylePicker = document.getElementById("text-style-picker");
  const letterKeyboard = document.getElementById("letter-keyboard");
  const emojiKeyboard = document.getElementById("emoji-keyboard");
  const previewText = document.getElementById("preview-text");
  const previewCollar = document.getElementById("preview-collar");
  const collarColorInput = document.getElementById("collar-color-input");
  const textColorInput = document.getElementById("custom-text-input");
  const emojiInput = document.getElementById("custom-text-emojis");

  if (!collarColorPicker || !textStylePicker || !letterKeyboard || !emojiKeyboard || !previewText || !previewCollar || !collarColorInput || !textColorInput || !emojiInput) {
    console.error("â Œ No se encontraron los elementos HTML necesarios.");
    return;
  }

  // Variable global: estilo actual seleccionado para el teclado (por defecto, el primer valor)
  let selectedStyle = coloresTexto[0] ? coloresTexto[0].trim() : "#000";

  // 1. Cargar botones para colores del collar
  function loadCollarColors() {
    if (coloresCollar.length === 0) {
      console.warn("âš ï¸  No hay colores disponibles para el collar.");
      return;
    }
    coloresCollar.forEach(color => {
      let btn = document.createElement("button");
      btn.classList.add("collar-color-option");
      btn.style.backgroundColor = color.trim();
      btn.dataset.color = color.trim();
      btn.addEventListener("click", () => {
        previewCollar.style.backgroundColor = color.trim();
        collarColorInput.value = color.trim();
        console.log("ðŸŽ¨ Collar cambiado a:", color.trim());
      });
      collarColorPicker.appendChild(btn);
    });
  }

  // 2. Cargar botones de estilos (colores o texturas) para el teclado
  function loadTextStyles() {
    if (coloresTexto.length === 0) {
      console.warn("âš ï¸  No hay estilos disponibles para el teclado.");
      return;
    }
    coloresTexto.forEach(styleVal => {
      let btn = document.createElement("button");
      btn.classList.add("text-style-option");
      if (styleVal.trim().startsWith("http")) {
        // Es una textura
        btn.style.backgroundImage = `url(${styleVal.trim()})`;
        btn.style.backgroundSize = "cover";
      } else {
        // Es un color
        btn.style.backgroundColor = styleVal.trim();
      }
      btn.dataset.value = styleVal.trim();
      btn.addEventListener("click", () => {
        selectedStyle = styleVal.trim();
        // Actualizar la apariencia de todas las teclas del teclado
        document.querySelectorAll(".char-button, .emoji-button").forEach(key => {
          const label = key.querySelector(".key-label");
          if (label) {
            // Limpiar propiedades previas:
            label.style.backgroundImage = "";
            label.style.backgroundSize = "";
            label.style.backgroundClip = "";
            label.style.webkitBackgroundClip = "";
            label.style.textShadow = "";
            if (selectedStyle.startsWith("http")) {
              // Aplicar textura
              label.style.backgroundImage = `url(${selectedStyle})`;
              label.style.backgroundSize = "cover";
              label.style.color = "transparent";
              label.style.backgroundClip = "text";
              label.style.webkitBackgroundClip = "text";
            } else {
              // Aplicar color
              label.style.backgroundImage = "none";
              // Para emojis, forzar recoloraciÃ³n con text-shadow
              if (key.classList.contains("emoji-button")) {
                label.style.color = "transparent";
                label.style.textShadow = `0 0 0 ${selectedStyle}`;
              } else {
                label.style.color = selectedStyle;
              }
            }
          }
        });
        console.log("âœ¨ Teclado actualizado al estilo:", selectedStyle);
      });
      textStylePicker.appendChild(btn);
    });
  }

function loadLetterKeyboard() {
  if (letterKeyboard.children.length === 0) {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    letras.split("").forEach((letra, index) => {
      let btn = document.createElement("button");
      btn.classList.add("char-button");

      let span = document.createElement("span");
      span.classList.add("key-label");
      span.textContent = letra;

      // ✅ aplicar color o textura según el tipo
      if (selectedStyle.startsWith("http")) {
        // Es una textura (URL)
        span.style.backgroundImage = `url(${selectedStyle})`;
        span.style.backgroundSize = "cover";
        span.style.backgroundClip = "text";
        span.style.webkitBackgroundClip = "text";
        span.style.color = "transparent";
      } else {
        // Es un color plano (#HEX, RGB, etc.)
        span.style.color = selectedStyle;
      }

      btn.appendChild(span);
      btn.dataset.value = letra;

      btn.addEventListener("click", () => {
        addCharacterToPreview(letra, false);
      });

      letterKeyboard.appendChild(btn);
    });
  }
}

function loadEmojis() {
  if (emojiKeyboard.children.length === 0) {
    if (emojisDisponibles.length === 0) {
      console.warn("⚠️ No hay emojis disponibles.");
    } else {
      emojisDisponibles.forEach(emojiChar => {
        let btn = document.createElement("button");
        btn.classList.add("emoji-button");

        let span = document.createElement("span");
        span.classList.add("key-label");
        span.textContent = emojiChar.trim();

        // ✅ aplicar color o textura
        if (selectedStyle.startsWith("http")) {
          // Textura
          span.style.backgroundImage = `url(${selectedStyle})`;
          span.style.backgroundSize = "cover";
          span.style.backgroundClip = "text";
          span.style.webkitBackgroundClip = "text";
          span.style.color = "transparent";
        } else {
          // Color plano
          span.style.color = "transparent";
          span.style.textShadow = `0 0 0 ${selectedStyle}`; // recoloriza emojis
        }

        btn.appendChild(span);
        btn.dataset.value = emojiChar.trim();

        btn.addEventListener("click", () => {
          addCharacterToPreview(emojiChar.trim(), true);
        });

        emojiKeyboard.appendChild(btn);
      });
    }
  }
}

function canAddMoreCharacters() {
  const total = previewText.children.length;
  const maxAllowed = parseInt(window.productCharacterLimit || 50);

  if (total >= maxAllowed) {
    //alert(`⚠️ Máximo ${maxAllowed} caracteres permitidos para este producto.`);
    return false;
  }

  return true;
}

  // 5. FunciÃ³n para agregar un carÃ¡cter (letra o emoji) a la vista previa sobre el collar
  // El parÃ¡metro isEmoji indica si es emoji (true) o letra (false)
  function addCharacterToPreview(char, isEmoji) {
     if (!canAddMoreCharacters()) return;
    let index = previewText.children.length;
    let span = document.createElement("span");
    span.classList.add("collar-char");
    span.dataset.index = index;
    if ((window.productTags || []).includes("correa")) {
  span.classList.add("small");
}
    
    let inner = document.createElement("span");
    inner.classList.add("key-label");
    inner.textContent = char;
    // Aplicar el estilo actual seleccionado a este carÃ¡cter
    if (selectedStyle.startsWith("http")) {
      inner.style.backgroundImage = `url(${selectedStyle})`;
      inner.style.backgroundSize = "cover";
      inner.style.backgroundClip = "text";
      inner.style.webkitBackgroundClip = "text";
      inner.style.color = "transparent";
      inner.dataset.texture = selectedStyle;
    } else {
      // Para emojis, si es color, forzar recoloraciÃ³n mediante text-shadow
      if (isEmoji) {
        inner.style.color = "transparent";
        inner.style.textShadow = `0 0 0 ${selectedStyle}`;
        inner.dataset.color = selectedStyle;
      } else {
        inner.style.backgroundImage = "none";
        inner.style.color = selectedStyle;
        inner.dataset.color = selectedStyle;
      }
    }
    span.appendChild(inner);
    // Al hacer clic sobre el carÃ¡cter en la vista previa, se elimina sin confirmaciÃ³n
    span.addEventListener("click", () => {
      span.remove();
      updateCartProperties();
    });
    previewText.appendChild(span);
    updateCartProperties();
  }

  // 6. FunciÃ³n para actualizar los inputs ocultos con la informaciÃ³n personalizada para el pedido
function updateCartProperties() {
  let collarColor = collarColorInput.value;
  let characters = [];
  // Usamos el contenedor correcto: #preview-text
  document.querySelectorAll("#preview-text .collar-char").forEach(span => {
    const label = span.querySelector(".key-label");
    if (label) {
      let letter = label.textContent;
      // Se busca en dataset.color y, si no está, en dataset.texture
      let color = label.dataset.color || label.dataset.texture || "";
      characters.push({ letter: letter, color: color });
    }
  });
  // Convertimos el array de objetos a JSON
  textColorInput.value = JSON.stringify(characters);
  emojiInput.value = JSON.stringify(characters);
  console.log("📦 Datos actualizados para el carrito:", { collarColor, characters });
}

  // 7. Inicializar la vista previa (comenzar vacÃ­a)
  function initializePreview() {
    previewText.innerHTML = "";
    updateCartProperties();
  }
  initializePreview();

    // Agregar event listener al formulario para actualizar inputs antes de enviar
  const productForm = document.querySelector("form[action='/cart/add']");
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      updateCartProperties();
      console.log("Formulario enviado con propiedades:", {
        collar: collarColorInput.value,
        customText: textColorInput.value,
        emojis: emojiInput.value
      });
    });
  }


  // Cargar las secciones iniciales
  loadCollarColors();
  loadTextStyles();
  loadLetterKeyboard();
  loadEmojis();

  console.log(" cargada correctamente.");
});